import { CmsInfoAccordionItem } from '@/components/Sections/InfoAccordion'
import orderBy from 'lodash/orderBy'

export type AlphabetisedKey = 'A-D' | 'E-H' | 'I-L' | 'M-Q' | 'U-Z'

export type SortedGlossaryTerms = Record<
  AlphabetisedKey,
  {
    regex: RegExp
    sortedTerms: CmsInfoAccordionItem[]
  }
>

export const useSortGlossaryTerms = (
  glossaryTerms: CmsInfoAccordionItem[],
): SortedGlossaryTerms => {
  const sorted: SortedGlossaryTerms = {
    'A-D': {
      regex: /[A-D]/,
      sortedTerms: [],
    },
    'E-H': {
      regex: /[E-H]/,
      sortedTerms: [],
    },
    'I-L': {
      regex: /[I-L]/,
      sortedTerms: [],
    },
    'M-Q': {
      regex: /[M-Q]/,
      sortedTerms: [],
    },
    'U-Z': {
      regex: /[U-Z]/,
      sortedTerms: [],
    },
  }

  glossaryTerms.forEach(term => {
    if (!term.fields) return
    term = {
      ...term,
      fields: { ...term.fields, title: term.fields.title.trim() },
    }
    ;(Object.keys(sorted) as AlphabetisedKey[]).forEach(chunk => {
      if (sorted[chunk].regex.test(term.fields.title.charAt(0))) {
        sorted[chunk].sortedTerms.push(term)
        sorted[chunk].sortedTerms = orderBy(sorted[chunk].sortedTerms, [
          'fields.title',
        ])
      }
    })
  })

  return sorted
}
